import { Navigate } from 'react-router-dom';
import { useUser } from '@mfox/shared/contexts/UserContext';
import { LoadingScreen } from './StatusScreen';

type ProtectedRouteProps = {
  requiredRoles?: string | string[];
  /** Set on the /onboarding/* routes themselves, so they don't redirect to
   *  themselves. Everything else routes a student with unfinished
   *  onboarding into /onboarding/skills first. */
  allowIncompleteOnboarding?: boolean;
  children: React.ReactNode;
};

export function ProtectedRoute({
  requiredRoles,
  allowIncompleteOnboarding,
  children,
}: ProtectedRouteProps) {
  const { currentUser, isLoading, isAuthorized } = useUser();

  if (isLoading) {
    return <LoadingScreen message="Loading…" />;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && !isAuthorized(requiredRoles)) {
    return <Navigate to="/" replace />;
  }

  // Explicit `=== false` (not just falsy): an unrelated caller building a
  // User without this field shouldn't be treated as "onboarding required".
  if (
    !allowIncompleteOnboarding &&
    currentUser.role === 'student' &&
    currentUser.onboardingComplete === false
  ) {
    return <Navigate to="/onboarding/skills" replace />;
  }

  return <>{children}</>;
}
